/**
 * @generated SignedSource<<bc5d76a3fb9975d02169e497a21fdcd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MakeOfferAction_artist$data = {
  readonly displayName: string;
  readonly " $fragmentSpreads": FragmentRefs<"useMessage_actor">;
  readonly " $fragmentType": "MakeOfferAction_artist";
};
export type MakeOfferAction_artist$key = {
  readonly " $data"?: MakeOfferAction_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"MakeOfferAction_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MakeOfferAction_artist",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMessage_actor"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "84f954353191c5a16452ecc3e42f98af";

export default node;
